import React from 'react';

export const Arrownext = () => {
    return(
        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" className='arrow-next'>
            <path d="M12.7182 17.2383L12.4852 17.4662L12.2521 17.2383L10.9703 15.985L10.7268 15.7468L10.9701 15.5085L16.3684 10.2222L0.666992 10.2222H0.333659L0.333659 9.88889L0.333659 8.11111V7.77778H0.666992L16.3684 7.77778L10.9701 2.49149L10.7268 2.25315L10.9703 2.015L12.2521 0.761665L12.4852 0.533804L12.7182 0.761665L20.9 8.76166L21.1438 9L20.9 9.23834L12.7182 17.2383Z" fill="#0E0E0E" stroke="#0E0E0E" strokeWidth="0.666667"/>
        </svg>
    )
}